import { Component, Input } from '@angular/core';
import { CalendarEvent } from 'calendar-utils';


export class CalendarEventActionsComponent {

   event: CalendarEvent;

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'mwl-calendar-event-actions',
  template: `
    <span *ngIf="event.actions" class="cal-event-actions">
      <a
        class="cal-event-action"
        href="javascript:;"
        *ngFor="let action of event.actions"
        (click)="action.onClick({event: event})"
        [ngClass]="action.cssClass">
        <md-icon>{{ action.label }}</md-icon>
      </a>
    </span>
  `
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'event': [{ type: Input },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
